import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.showTopButton)?_c(VBtn,{staticClass:"btn btn-to-top",attrs:{"fab":"","small":"","fixed":"","right":"","bottom":""},on:{"click":_vm.goToTop}},[_c(VIcon,{attrs:{"color":"white"}},[_vm._v("mdi-arrow-up")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }